var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnSiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0C3.70049 0 0.609375 3.09111 0.609375 6.89062C0.609375 8.10682 0.930703 9.30252 1.53859 10.3484C1.6803 10.5923 1.83872 10.8299 2.00951 11.0547L7.20061 18H7.79936L12.9905 11.0547C13.1612 10.8299 13.3197 10.5923 13.4614 10.3485C14.0693 9.30252 14.3906 8.10682 14.3906 6.89062C14.3906 3.09111 11.2995 0 7.5 0ZM7.5 9.17578C6.23996 9.17578 5.21484 8.15066 5.21484 6.89062C5.21484 5.63059 6.23996 4.60547 7.5 4.60547C8.76004 4.60547 9.78516 5.63059 9.78516 6.89062C9.78516 8.15066 8.76004 9.17578 7.5 9.17578Z",
    fill: "#641793"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnSiteIcon);
export default __webpack_public_path__ + "static/media/on_site_icon.11d627049ed5b9020dca0b98d13a4eea.svg";
export { ForwardRef as ReactComponent };